export const SECTION_HEADER_HEIGHT = 20; // px
export const CENTRAL_SECTION_BORDER_RADIUS = 6; // px
export const PROGRESS_BAR = {
  HEIGHT: 30, // px
  BORDER_RADIUS: 8, // px
};
